import classNames from 'classnames'
import React from 'react'

import Image from '@/components/Image'
import Link from '@/components/Link'

const NavLink = ({link, Label, description, icon, badge, badgeColor, align = 'center'}) => {
  return (
    <Link
      link={link}
      className={classNames(
        'group flex gap-3 rounded px-2 py-3 transition duration-200 hover:bg-violet-200',
        {
          'items-start': align === 'top',
          'items-center': align === 'center',
        }
      )}
    >
      <div className='flex h-10 w-10 flex-[none] items-center justify-center rounded-md bg-violet-200'>
        <Image {...icon} ratio='1:1' />
      </div>
      <div className='flex w-[fit-content] flex-col'>
        <span className='body-s-medium flex items-start gap-2 text-purple-900'>
          {Label}
          {badge && (
            <div>
              <span
                className={classNames(
                  'misc-button-s relative z-10 rounded-lg px-2 py-1 uppercase',
                  {
                    'bg-purple-400 text-white': badgeColor === 'purple' || badgeColor === '',
                    'bg-turquoise-400 text-purple-900': badgeColor === 'turquoise',
                    'bg-violet-400': badgeColor === 'violet',
                    'bg-yellow-400 text-purple-900': badgeColor === 'yellow',
                  }
                )}
              >
                {badge}
              </span>
            </div>
          )}
        </span>
        <span className='body-xs-regular text-purple-400'>{description}</span>
      </div>
    </Link>
  )
}

export default NavLink
